import { Chart } from '@frontend/chart/types';

export const EQUIPMENT_CERTIFICATIONS_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'certified',
            data: [{ label: 'certified', value: 40 }]
        },
        {
            name: 'expires_soon',
            data: [{ label: 'expires_soon', value: 12 }]
        },
        {
            name: 'expired',
            data: [{ label: 'expired', value: 10 }]
        }
    ]
};
